import { get } from "@insite/client-framework/Services/ApiService";

export async function GetSignInUrl() {
    const rightShipPortalSettingsResponse = await get<string>(`/api/v1/RightShipPortalSettings/SignInUrl`);
    if (rightShipPortalSettingsResponse) {
        return rightShipPortalSettingsResponse
    }
    return "";
}